import { ReactNode } from 'react';

import { isPrideMonth } from '@arrived/common';
import {
  ArrivedLogoIcon,
  ArrivedLogoImage,
  ArrivedLogoWhiteIcon,
  ArrivedLogoWhiteImage,
  PrideIcon,
  PrideLogo,
} from '@arrived/images';

import { NavArrivedLogo } from './NavArrivedLogo';

interface ArrivedGradientTopNavLogoProps {
  isIconOnly?: boolean;
  isWhiteLogo?: boolean;
  className?: string;
}

type IconMap = Record<string, ReactNode>;
const ICON_ONLY_MAP: IconMap = {
  prideMonth: <PrideIcon />,
  standard: <ArrivedLogoIcon />,
  white: <ArrivedLogoWhiteIcon />,
};

const ICON_MAP: IconMap = {
  prideMonth: <PrideLogo />,
  standard: <ArrivedLogoImage />,
  white: <ArrivedLogoWhiteImage />,
};

export const NavigationArrivedLogo = (props: ArrivedGradientTopNavLogoProps) => {
  const { isIconOnly, isWhiteLogo, className } = props;
  let logoKey = 'standard';

  if (isPrideMonth) {
    logoKey = 'prideMonth';
  }

  if (isWhiteLogo) {
    logoKey = 'white';
  }

  return (
    <NavArrivedLogo className={className} isOnlyLogo={isIconOnly}>
      {isIconOnly ? ICON_ONLY_MAP[logoKey] : ICON_MAP[logoKey]}
    </NavArrivedLogo>
  );
};
